import { Injectable } from '@angular/core';
import { ApiError, AuthHeaders } from '@fleet-beat/core';
import * as signalR from '@microsoft/signalr';
import { Observable, catchError, from, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignalrService {
  connect(hubUrl: string, auth: AuthHeaders): Observable<signalR.HubConnection> {
    const url: URL = new URL(hubUrl);
    const connection: signalR.HubConnection = new signalR.HubConnectionBuilder()
      .withUrl(url.toString(), {
        accessTokenFactory: () => auth.token,
      })
      .build();

    return from(connection.start()).pipe(
      map(() => connection),
      catchError(this.catchHubError),
    );
  }

  catchHubError(error: Error): never {
    throw new ApiError([error.message]);
  }
}
